export const contactHero = {
  title: "Get in touch",
  subtitle: "For partnerships, support, or general enquiries",
};

export const contactChannels = [
  {
    title: "General enquiries",
    description: "Questions about using Pawwash or finding a station near you.",
    email: "support@pawwash.co.uk",
  },
  {
    title: "Partnerships",
    description: "Interested in hosting a Pawwash station at your location?",
    email: "partners@pawwash.co.uk",
  },
];

export const socialLinks = [
  {
    name: "Facebook",
    url: "https://www.facebook.com/profile.php?id=61550823506649",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/pawwash_uk/",
    handle: "@pawwash_uk",
  },
  {
    name: "Twitter / X",
    url: "https://twitter.com/pawwash_uk",
    handle: "@pawwash_uk",
  },
];

export const contactNote =
  "Contact form coming soon. For location-specific questions, visit our home page to find your nearest station.";

export const contactMeta = {
  title: "Contact | Pawwash",
  description:
    "Contact Pawwash for support, partnerships, or general enquiries. Follow us on social media for updates.",
  path: "/contact",
};
